import React, { Fragment, FunctionComponent } from "react";
import ContentPageProps from "./ContentPageProps.interface";

import ContentPageBlock from "./ContentPage.block";

const ContentPage: FunctionComponent<ContentPageProps> = (props) => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent, index) => {
                return (
                    <ContentPageBlock key={blockContent?.contentUdi} {...blockContent} />
                );
            })}
        </Fragment>
    );
};

export default ContentPage;